import ScheduleYourCall from '@/evercall/ui/components/ScheduleYourCall';
import { LandingLayout } from '@/evercall/ui/common/Layout';
import withApplicationProps from '@/evercall/application/withApplicationProps';

import layoutStyles from '@/evercall/ui/common/Layout/layout.module.scss';

export const getServerSideProps = withApplicationProps(() => ({ props: {} }));

export default (): React.ReactNode => {
  return (
    <LandingLayout containerCls={ layoutStyles.landingHomeContainer }>
      <ScheduleYourCall />
    </LandingLayout>
  );
};
